import React from "react";
import { Toggle } from "react-powerplug";
import { useSlate } from "slate-react";
import { Transforms } from "slate";
import Button from "../Button";
import { Modal } from "@govlaunch/core";
import CustomButtonInput from "../inputs/CustomButtonInput";
import { ELEMENT_CUSTOM_BUTTON, EMPTY_CHILDREN, getNewParagraph } from "../../Element";
import Icon, { ICON_CUSTOM_BUTTON } from "../Icon";

export default function InsertCustomButtonButton() {
  const editor = useSlate();

  return (
    <Toggle>
      {({ on, toggle }) => (
        <>
          <Modal
            isOpen={on}
            style={{
              boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)",
              borderRadius: 4,
            }}
            onRequestClose={() => toggle()}
            appElement={document.body}
          >
            <CustomButtonInput
              onInsert={(customButtonData) => {
                const {
                  buttonText,
                  buttonURL,
                  buttonColor,
                  buttonTextColor,
                  buttonBorderColor,
                  buttonWidth,
                  buttonTargetBlank,
                } = customButtonData;

                const customButton = [
                  {
                    type: ELEMENT_CUSTOM_BUTTON,
                    buttonText,
                    buttonURL,
                    buttonColor,
                    buttonTextColor,
                    buttonBorderColor,
                    buttonWidth,
                    buttonTargetBlank,
                    ...EMPTY_CHILDREN,
                  },
                  getNewParagraph(),
                ];

                Transforms.insertNodes(editor, customButton);

                toggle();
              }}
            />
          </Modal>
          <Button
            onMouseDown={(event) => {
              event.preventDefault();
              // check for left click
              if (event.button === 0) {
                toggle();
              }
            }}
          >
            <Icon iconName={ICON_CUSTOM_BUTTON} />
          </Button>
        </>
      )}
    </Toggle>
  );
}
